import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BrainCircuit, Loader2, RefreshCw } from 'lucide-react';
import AddSkillInput from './AddSkillInput';
import EmptySkillsState from './EmptySkillsState';
import LoadingSkeleton from './LoadingSkeleton';
import SkillChip from './SkillChip';
import { profileCard } from './ProfileUI';

const ProfileSkillsReviewSection = ({
  skills = [],
  isLoading = false,
  isSaving = false,
  onAddSkill,
  onRemoveSkill,
  onRefresh,
}) => (
  <motion.section
    initial={{ opacity: 0, y: 18 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.35 }}
    className={profileCard}
  >
    <div className="mb-5 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-purple-300">Profile Review</p>
        <h2 className="mt-2 flex items-center gap-2 text-2xl font-bold text-white">
          <BrainCircuit className="h-6 w-6 text-pink-300" />
          Extracted Skills Review
        </h2>
        <p className="mt-2 max-w-2xl text-sm leading-6 text-gray-400">
          These reviewed skills power role recommendations, dashboard readiness, roadmaps, and project suggestions.
        </p>
      </div>
      <button
        type="button"
        onClick={onRefresh}
        disabled={isLoading || isSaving}
        className="inline-flex items-center justify-center gap-2 rounded-lg border border-purple-300/30 bg-purple-500/10 px-4 py-2 text-sm font-semibold text-purple-100 transition hover:-translate-y-0.5 hover:border-pink-300/60 hover:bg-pink-500/15 disabled:cursor-not-allowed disabled:opacity-60"
      >
        {isLoading ? <Loader2 className="h-4 w-4 animate-spin" /> : <RefreshCw className="h-4 w-4" />}
        Refresh
      </button>
    </div>

    {isLoading ? (
      <LoadingSkeleton />
    ) : skills.length ? (
      <div className="flex flex-wrap gap-3">
        <AnimatePresence>
          {skills.map((skill) => (
            <SkillChip key={skill.id || skill.skill_name || skill.name} skill={skill} onRemove={onRemoveSkill} disabled={isSaving} />
          ))}
        </AnimatePresence>
      </div>
    ) : (
      <EmptySkillsState />
    )}

    <AddSkillInput skills={skills} onAdd={onAddSkill} disabled={isSaving} />
  </motion.section>
);

export default ProfileSkillsReviewSection;

